import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n";
import { Sparkles, LayoutGrid, ShoppingBag, Inbox, Shield } from "lucide-react";

export function BottomNav() {
  const { user } = useAuth();
  const { t } = useT();
  const loc = useLocation();
  if (!user) return null;

  const items = [
    { to: "/studio", label: "Foto", icon: Sparkles, roles: ["admin", "sales", "client"] },
    { to: "/projects", label: "Proiecte", icon: LayoutGrid, roles: ["admin", "sales", "client"] },
    { to: "/catalog", label: "Catalog", icon: ShoppingBag, roles: ["admin", "sales", "client"] },
    { to: "/sales", label: "Cereri", icon: Inbox, roles: ["admin", "sales"] },
    { to: "/admin", label: "Admin", icon: Shield, roles: ["admin"] },
  ].filter((i) => i.roles.includes(user.role));

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 glass border-t border-slate-800"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="flex items-stretch justify-around h-16">
        {items.map((i) => {
          const active = loc.pathname === i.to;
          const Icon = i.icon;
          return (
            <Link key={i.to} to={i.to} data-testid={`bottomnav-${i.to.slice(1)}`}
              className={`flex-1 flex flex-col items-center justify-center gap-1 min-h-[44px] transition-colors ${
                active ? "text-primary" : "text-slate-400"
              }`}>
              <Icon className={`w-5 h-5 ${active ? "text-primary" : ""}`} />
              <span className="text-[10px] font-medium">{t(i.label)}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
